var map = {
	"./project/icon/4g_icon.svg": "660b",
	"./project/icon/age_icon.svg": "f992",
	"./project/icon/consti_icon.svg": "16ae",
	"./project/icon/gender_icon.svg": "b7dd",
	"./project/icon/ministry_icon.svg": "1383",
	"./project/icon/search_icon.svg": "f1dc",
	"./project/icon/type.svg": "6eb8",
	"./project/icon/type_icon.svg": "e158",
	"./project/icon/yr_icon.svg": "42c8",
	"./template/sample-logo.svg": "2bfb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9c4a";